import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import qs from 'qs';
import i18n from 'i18n-js';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';
import { BastionContext } from 'context';
import { AuthLayout } from 'components/UI';
import { Typography, Box } from '@mui/material';
import { AuthActions } from 'state/modules/auth';
import CheckIcon from '@mui/icons-material/Check';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const Error = ({ message }) => {
  return (
    <>
      <Box>
        <ErrorOutlineIcon color="error" style={{ fontSize: 60 }} />
      </Box>
      <Typography color="textSecondary" component="div" align="center">
        <Box fontSize={14} mt={3} component="p" fontWeight="fontWeightBold">
          {typeof message === 'string' && message}
        </Box>
      </Typography>
    </>
  );
};

const ConfirmEmailPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const { theme } = useContext(BastionContext);
  const [token, setToken] = useState(null);

  const { loading, fetchedEmailConfirm, errors } = useSelector((state) => state.auth);

  useEffect(() => {
    const { token } = qs.parse(location.search.substring(1));
    setToken(token);

    if (token) {
      dispatch(AuthActions.fetchConfirmEmail(token));
    }
  }, [dispatch, location.search, setToken, token]);

  return (
    <AuthLayout title={`${theme.page.title} | ${i18n.t('auth.confirm_email')}`}>
      <Box
        height="100%"
        display="flex"
        alignItems="center"
        flexDirection="column"
        justifyContent="center"
      >
        {!token ? (
          <Error message={i18n.t('auth.missing_token')} />
        ) : (
          <>
            {loading ? (
              <Loading />
            ) : (
              <>
                {fetchedEmailConfirm ? (
                  <>
                    <Box
                      width={100}
                      height={100}
                      display="flex"
                      borderRadius="50%"
                      alignItems="center"
                      bgcolor="#4D4F5C08"
                      justifyContent="center"
                    >
                      <CheckIcon style={{ color: '#0181FF', fontSize: 60 }} />
                    </Box>
                    <Typography color="textPrimary" component="div" align="center">
                      <Box fontSize={18} mt={4} component="p" fontWeight="fontWeightBold">
                        {i18n.t('auth.confirmEmail')}
                      </Box>
                    </Typography>
                    <Typography color="textSecondary" component="div" align="center">
                      <Box fontSize={14} mt={3} component="p" fontWeight="fontWeightBold">
                        {i18n.t('auth.confirmEmailText')}
                      </Box>
                    </Typography>
                  </>
                ) : (
                  <Error message={errors} />
                )}
              </>
            )}
          </>
        )}
      </Box>
    </AuthLayout>
  );
};

Error.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default ConfirmEmailPage;
